import { motion } from "framer-motion";
import "./Employee.css";
import E1 from "./assets/e1.png";
import E2 from "./assets/e2.png";
import E3 from "./assets/e3.png";
import E4 from "./assets/e4.png";
import E5 from "./assets/e5.png";

const EmployeeKeyBenefits = () => {
  const data = [
    {
      id: "operational-efficiency",
      title: "Operational Efficiency",
      text: "Strategic initiatives transform HR into a key business partner driving measurable growth.",
      icon: E1,
    },
    {
      id: "data-accuracy",
      title: "Data Accuracy",
      text: "ESS empowers employees to manage their data accurately, reducing errors and enhancing satisfaction organization-wide.",
      icon: E2,
    },
    {
      id: "employee-satisfaction",
      title: "Employee Satisfaction",
      text: "Transparency and autonomy build trust, boost morale, and enhance employee engagement and retention.",
      icon: E3,
    },
    {
      id: "critical-workflows",
      title: "Critical Workflows",
      text: "Eliminates bottlenecks, speeds approvals, and streamlines workflows for greater efficiency and predictability.",
      icon: E4,
    },
    {
      id: "cost-reduction",
      title: "Cost Reduction",
      text: "Digitizing and automating processes cut costs and effort, delivering clear financial benefits.",
      icon: E5,
    },
  ];

  return (
    <motion.div
      className="gate-functions-container"
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <motion.h2
        className="gate-functions-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.8 }}
        viewport={{ once: true }}
      >
        Key Benefits of <br />
        Employee Self Service
      </motion.h2>
      <motion.div
        className="gate-functions-grid"
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {data.map((item, i) => (
          <motion.div
            key={item.id} 
            className="electric-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 + i * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="electric-border"></div>
            <div className="electric-content">
              <div className="icon-wrapper">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="electric-icon"
                />
              </div>
              <h3 className="electric-title">{item.title}</h3>
              <p className="electric-text">{item.text}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default EmployeeKeyBenefits;
